export default "__VITE_ASSET__COV8YJgN__"